import { Timestamp, toDateTimeStr, toTimestamp } from '@mi-front/core';
import { LocaleTime } from '@mi-front/ui';
import FlagIcon from '@mui/icons-material/Flag';
import { FormattedMessage, useIntl } from 'react-intl';
import { Pre, SubTitle, Title, Wrapper } from '../focus-markers/live-mentions/components/elements';
import { isNumeric } from '../transcriptions/utils';
import { DiarizationPlayBtn } from './DiarizarionPlayBtn';
import { getConfidenceLabel } from './utils';

export function DiarizationInfo({ diarization }: { diarization: any }) {
  const { time, segment, voice_label, description, distance } = diarization;
  const { formatMessage } = useIntl();
  const timeStamp = toTimestamp(time) + segment.start * 1000;

  return (
    <Wrapper>
      <>
        <Pre>
          {formatMessage({
            id: 'audit.diarization.speaker',
            defaultMessage: 'Speaker Label',
          })}
        </Pre>
        <Title>
          {voice_label
            .split('-')
            .map((item: string) => item.toUpperCase())
            .filter((value: string) => !isNumeric(value))
            .join(' ')}
        </Title>
        <SubTitle>{description}</SubTitle>
      </>
      <div>
        <FlagIcon sx={{ fontSize: 'inherit', verticalAlign: 'middle' }} />{' '}
        <LocaleTime
          hour="2-digit"
          minute="2-digit"
          second="2-digit"
          value={toDateTimeStr(timeStamp)}
        />
      </div>
      <div>
        <FormattedMessage id="logger.diarization.confidence" defaultMessage="Confidence:" />
        {getConfidenceLabel(Math.round(distance * 100))}
        {`(${Math.round(distance * 100) / 100})`}
      </div>
      <DiarizationPlayBtn time={timeStamp as Timestamp} />
    </Wrapper>
  );
}
